import { PaymentType } from '@truepill/tpos-types'

const isCashPaymentType = (paymentType: string) => {
  return paymentType === PaymentType.Cash
}

export default isCashPaymentType
